// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

/* Basis Styling (Standaard = Dark Mode) */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: black;
  color: white;
}

@media (orientation: landscape) and (max-height: 500px) {
  .focus-hide { display: none !important; }
  .timer-display { font-size: 15vw !important; margin-top: 1rem !important; margin-bottom: 0.5rem !important; line-height: 1 !important; }
  .focus-round-info { font-size: 1.25rem !important; margin-bottom: 0 !important; color: #9ca3af !important; }
  .focus-controls { margin-top: 0 !important; transform: scale(0.9); }
  .focus-controls button { padding: 1rem !important; }
}
.pt-safe { padding-top: env(safe-area-inset-top); }

.focus-mode-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: max(2rem, env(safe-area-inset-top)) !important;
  padding-bottom: max(2rem, env(safe-area-inset-bottom)) !important;
  padding-left: max(1rem, env(safe-area-inset-left)) !important;
  padding-right: max(1rem, env(safe-area-inset-right)) !important;
  transition: background-color 0.4s ease;
  background-color: black;
  color: white;
  position: relative;
  z-index: 50;
}
.top-safe-absolute { top: max(2rem, env(safe-area-inset-top)); }

/* =========================================================
   ⚡ PRO ATHLETIC LIGHT MODE (NIKE / SWORKIT / RUNKEEPER STYLE)
   Met hoog contrast, scherpe lijnen en een strakke Focus Mode
   ========================================================= */

body.light-theme .focus-mode-container {
  background-color: #f1f5f9 !important;
  color: #09090b !important;
}

/* 1. Hoofdkaarten, Builder-kaarten & Modals -> Crisp Wit met strakke slate/antraciet rand */
body.light-theme .bg-zinc-900\\/90,
body.light-theme .bg-zinc-900\\/80,
body.light-theme .bg-zinc-900\\/70,
body.light-theme .bg-zinc-900,
body.light-theme .bg-zinc-950,
body.light-theme .bg-gray-900\\/80,
body.light-theme .bg-gray-800,
body.light-theme .bg-\\[\\#121214\\],
body.light-theme .bg-\\[\\#18181b\\],
body.light-theme .bg-\\[\\#0f0f11\\] {
  background-color: #ffffff !important;
  border-color: #94a3b8 !important;
  color: #09090b !important;
  box-shadow: 0 4px 16px -2px rgba(9, 9, 11, 0.08), 0 1px 4px -1px rgba(9, 9, 11, 0.05) !important;
}

/* 2. Focus Mode Set-Rijen (.workout-set-row) in Light Mode -> Geen zwarte balken meer! */
body.light-theme .workout-set-row {
  background-color: #f8fafc !important;
  border: 1px solid #cbd5e1 !important;
  box-shadow: 0 1px 2px rgba(9, 9, 11, 0.03) !important;
}

body.light-theme .workout-set-row.set-done {
  background-color: #ecfdf5 !important;
  border-color: #34d399 !important;
}

body.light-theme .workout-set-row .set-input-box {
  background-color: #ffffff !important;
  border: 1px solid #94a3b8 !important;
}

body.light-theme .workout-set-row .set-type-btn {
  background-color: #e2e8f0 !important;
  border-color: #94a3b8 !important;
  color: #09090b !important;
}

body.light-theme .workout-set-row .set-minus-btn {
  background-color: #fee2e2 !important;
  color: #dc2626 !important;
}

body.light-theme .workout-set-row .set-plus-btn {
  background-color: #dcfce7 !important;
  color: #16a34a !important;
}

body.light-theme .workout-set-row .set-check-btn:not(.bg-green-600) {
  background-color: #ffffff !important;
  border-color: #94a3b8 !important;
  color: #16a34a !important;
}

/* 3. Focus Mode Coach Advies blok -> Helder en scherp leesbaar in Light Mode */
body.light-theme .bg-indigo-950\\/20 {
  background-color: #ffffff !important;
  border: 1px solid #94a3b8 !important;
  border-left: 4px solid #4f46e5 !important;
}
body.light-theme .text-indigo-200 {
  color: #1e293b !important;
}
body.light-theme .text-indigo-400 {
  color: #4338ca !important;
}

/* 4. De 8 Stats KPI-Tegels -> Strak wit met scherpe rand */
body.light-theme .from-white\\/10.to-black\\/50 {
  background-image: none !important;
  background-color: #ffffff !important;
  border-color: #94a3b8 !important;
  box-shadow: 0 2px 8px rgba(9, 9, 11, 0.05) !important;
}

body.light-theme .from-white\\/10.to-black\\/50 .bg-black\\/40 {
  background-color: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

/* 5. Sub-kaarten, Blokken & Logboek-rijen -> Koel Atletisch Lichtgrijs (#f8fafc) met duidelijke lijn */
body.light-theme .bg-\\[\\#141414\\],
body.light-theme .bg-\\[\\#1a1a1a\\],
body.light-theme .bg-\\[\\#1e1e1e\\],
body.light-theme .bg-zinc-800,
body.light-theme .bg-zinc-800\\/10,
body.light-theme .bg-zinc-800\\/30,
body.light-theme .bg-zinc-800\\/40,
body.light-theme .bg-zinc-800\\/50,
body.light-theme .bg-zinc-800\\/80,
body.light-theme .bg-black\\/20,
body.light-theme .bg-black\\/30,
body.light-theme .bg-black\\/40,
body.light-theme .bg-black\\/50,
body.light-theme .bg-black\\/60,
body.light-theme .bg-white\\/5 {
  background-color: #f8fafc !important;
  border-color: #94a3b8 !important;
  color: #09090b !important;
}

body.light-theme .bg-zinc-800\\/30.border-orange-500\\/20 {
  background-color: #f8fafc !important;
  border-color: #94a3b8 !important;
  border-left: 4px solid #f97316 !important;
}

/* 6. Duidelijke, scherpe randen in Light Mode (#94a3b8 slate-400 voor echt contrast) */
body.light-theme .border-orange-500\\/20,
body.light-theme .border-orange-500\\/30,
body.light-theme .border-white\\/5,
body.light-theme .border-white\\/10,
body.light-theme .border-white\\/20,
body.light-theme .border-gray-700,
body.light-theme .border-gray-800,
body.light-theme .border-zinc-600,
body.light-theme .border-zinc-700,
body.light-theme .border-zinc-700\\/50,
body.light-theme .border-zinc-800 {
  border-color: #94a3b8 !important;
}

/* Behoud dikke gekleurde linker-accentbalken op oefeningkaarten */
body.light-theme .border-l-orange-500 {
  border-left: 4px solid #f97316 !important;
}
body.light-theme .border-l-yellow-500 {
  border-left: 4px solid #eab308 !important;
}
body.light-theme .border-l-cyan-500 {
  border-left: 4px solid #06b6d4 !important;
}

/* 7. Typografie: Diep Zwart (#09090b) & Koel Slate-Grijs */
body.light-theme .text-white:not(button):not(.bg-red-600):not(.bg-green-600):not(.bg-orange-500):not(.bg-orange-600):not(.bg-blue-600):not(.bg-emerald-600) {
  color: #09090b !important;
}

body.light-theme .text-gray-200,
body.light-theme .text-gray-300,
body.light-theme .text-zinc-200,
body.light-theme .text-zinc-300 {
  color: #18181b !important;
}

body.light-theme .text-gray-400,
body.light-theme .text-gray-500,
body.light-theme .text-zinc-400,
body.light-theme .text-zinc-500 {
  color: #475569 !important;
}

/* 8. Invulvelden, Dropdowns & Sliders */
body.light-theme input:not([type="radio"]):not([type="checkbox"]):not([type="range"]),
body.light-theme select,
body.light-theme textarea {
  background-color: #ffffff !important;
  color: #09090b !important;
  border-color: #64748b !important;
}

body.light-theme .workout-set-row input {
  background-color: transparent !important;
  border: none !important;
}

body.light-theme input[type="range"] {
  background-color: #cbd5e1 !important;
  accent-color: #09090b !important;
}

/* 9. Behoud altijd witte tekst op gekleurde actie-knoppen */
body.light-theme button.from-orange-600,
body.light-theme button.from-cyan-600,
body.light-theme button.from-emerald-600,
body.light-theme button.from-purple-600,
body.light-theme button.from-yellow-600,
body.light-theme button.from-blue-600,
body.light-theme button.bg-red-600,
body.light-theme button.bg-green-600,
body.light-theme button.bg-emerald-600,
body.light-theme button.bg-orange-500,
body.light-theme button.bg-orange-600,
body.light-theme button.bg-blue-600,
body.light-theme .bg-red-600,
body.light-theme .bg-green-600,
body.light-theme .bg-emerald-600 {
  color: #ffffff !important;
}

body.light-theme button.from-orange-600 *,
body.light-theme button.from-cyan-600 *,
body.light-theme button.from-emerald-600 *,
body.light-theme button.from-purple-600 *,
body.light-theme button.from-yellow-600 *,
body.light-theme button.from-blue-600 *,
body.light-theme button.bg-emerald-600 *,
body.light-theme .bg-red-600 *,
body.light-theme .bg-green-600 * {
  color: #ffffff !important;
}

body.light-theme .workout-set-row .set-weight-btn {
  color: #09090b !important;
}
body.light-theme .workout-set-row .set-weight-btn:hover {
  color: #ea580c !important;
}

body.light-theme .bg-zinc-900\\/60,
body.light-theme .bg-zinc-900\\/40,
body.light-theme .bg-zinc-800\\/60 {
  background-color: #f8fafc !important;
  color: #09090b !important;
}

body.light-theme button.from-blue-600,
body.light-theme button.from-indigo-600 {
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB,0CAA0C;AAC1C;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc,wBAAwB,EAAE;EACxC,iBAAiB,0BAA0B,EAAE,2BAA2B,EAAE,gCAAgC,EAAE,yBAAyB,EAAE;EACvI,oBAAoB,6BAA6B,EAAE,2BAA2B,EAAE,yBAAyB,EAAE;EAC3G,kBAAkB,wBAAwB,EAAE,qBAAqB,EAAE;EACnE,yBAAyB,wBAAwB,EAAE;AACrD;AACA,WAAW,qCAAqC,EAAE;;AAElD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;EAC7D,+DAA+D;EAC/D,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA,qBAAqB,wCAAwC,EAAE;;AAE/D;;;8DAG8D;;AAE9D;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,4FAA4F;AAC5F;;;;;;;;;;EAUE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,gGAAgG;AAClG;;AAEA,yFAAyF;AACzF;EACE,oCAAoC;EACpC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,uGAAuG;AACvG;;;;;;;;;;;;;;;EAeE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,uFAAuF;AACvF;;;;;;;;;;;EAWE,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,4DAA4D;AAC5D;;;;;;;;;;;;;;;EAeE,yBAAyB;AAC3B;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Basis Styling (Standaard = Dark Mode) */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: black;\n  color: white;\n}\n\n@media (orientation: landscape) and (max-height: 500px) {\n  .focus-hide { display: none !important; }\n  .timer-display { font-size: 15vw !important; margin-top: 1rem !important; margin-bottom: 0.5rem !important; line-height: 1 !important; }\n  .focus-round-info { font-size: 1.25rem !important; margin-bottom: 0 !important; color: #9ca3af !important; }\n  .focus-controls { margin-top: 0 !important; transform: scale(0.9); }\n  .focus-controls button { padding: 1rem !important; }\n}\n.pt-safe { padding-top: env(safe-area-inset-top); }\n\n.focus-mode-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: max(2rem, env(safe-area-inset-top)) !important;\n  padding-bottom: max(2rem, env(safe-area-inset-bottom)) !important;\n  padding-left: max(1rem, env(safe-area-inset-left)) !important;\n  padding-right: max(1rem, env(safe-area-inset-right)) !important;\n  transition: background-color 0.4s ease;\n  background-color: black;\n  color: white;\n  position: relative;\n  z-index: 50;\n}\n.top-safe-absolute { top: max(2rem, env(safe-area-inset-top)); }\n\n/* =========================================================\n   ⚡ PRO ATHLETIC LIGHT MODE (NIKE / SWORKIT / RUNKEEPER STYLE)\n   Met hoog contrast, scherpe lijnen en een strakke Focus Mode\n   ========================================================= */\n\nbody.light-theme .focus-mode-container {\n  background-color: #f1f5f9 !important;\n  color: #09090b !important;\n}\n\n/* 1. Hoofdkaarten, Builder-kaarten & Modals -> Crisp Wit met strakke slate/antraciet rand */\nbody.light-theme .bg-zinc-900\\/90,\nbody.light-theme .bg-zinc-900\\/80,\nbody.light-theme .bg-zinc-900\\/70,\nbody.light-theme .bg-zinc-900,\nbody.light-theme .bg-zinc-950,\nbody.light-theme .bg-gray-900\\/80,\nbody.light-theme .bg-gray-800,\nbody.light-theme .bg-\\[\\#121214\\],\nbody.light-theme .bg-\\[\\#18181b\\],\nbody.light-theme .bg-\\[\\#0f0f11\\] {\n  background-color: #ffffff !important;\n  border-color: #94a3b8 !important;\n  color: #09090b !important;\n  box-shadow: 0 4px 16px -2px rgba(9, 9, 11, 0.08), 0 1px 4px -1px rgba(9, 9, 11, 0.05) !important;\n}\n\n/* 2. Focus Mode Set-Rijen (.workout-set-row) in Light Mode -> Geen zwarte balken meer! */\nbody.light-theme .workout-set-row {\n  background-color: #f8fafc !important;\n  border: 1px solid #cbd5e1 !important;\n  box-shadow: 0 1px 2px rgba(9, 9, 11, 0.03) !important;\n}\n\nbody.light-theme .workout-set-row.set-done {\n  background-color: #ecfdf5 !important;\n  border-color: #34d399 !important;\n}\n\nbody.light-theme .workout-set-row .set-input-box {\n  background-color: #ffffff !important;\n  border: 1px solid #94a3b8 !important;\n}\n\nbody.light-theme .workout-set-row .set-type-btn {\n  background-color: #e2e8f0 !important;\n  border-color: #94a3b8 !important;\n  color: #09090b !important;\n}\n\nbody.light-theme .workout-set-row .set-minus-btn {\n  background-color: #fee2e2 !important;\n  color: #dc2626 !important;\n}\n\nbody.light-theme .workout-set-row .set-plus-btn {\n  background-color: #dcfce7 !important;\n  color: #16a34a !important;\n}\n\nbody.light-theme .workout-set-row .set-check-btn:not(.bg-green-600) {\n  background-color: #ffffff !important;\n  border-color: #94a3b8 !important;\n  color: #16a34a !important;\n}\n\n/* 3. Focus Mode Coach Advies blok -> Helder en scherp leesbaar in Light Mode */\nbody.light-theme .bg-indigo-950\\/20 {\n  background-color: #ffffff !important;\n  border: 1px solid #94a3b8 !important;\n  border-left: 4px solid #4f46e5 !important;\n}\nbody.light-theme .text-indigo-200 {\n  color: #1e293b !important;\n}\nbody.light-theme .text-indigo-400 {\n  color: #4338ca !important;\n}\n\n/* 4. De 8 Stats KPI-Tegels -> Strak wit met scherpe rand */\nbody.light-theme .from-white\\/10.to-black\\/50 {\n  background-image: none !important;\n  background-color: #ffffff !important;\n  border-color: #94a3b8 !important;\n  box-shadow: 0 2px 8px rgba(9, 9, 11, 0.05) !important;\n}\n\nbody.light-theme .from-white\\/10.to-black\\/50 .bg-black\\/40 {\n  background-color: #f1f5f9 !important;\n  border-color: #cbd5e1 !important;\n}\n\n/* 5. Sub-kaarten, Blokken & Logboek-rijen -> Koel Atletisch Lichtgrijs (#f8fafc) met duidelijke lijn */\nbody.light-theme .bg-\\[\\#141414\\],\nbody.light-theme .bg-\\[\\#1a1a1a\\],\nbody.light-theme .bg-\\[\\#1e1e1e\\],\nbody.light-theme .bg-zinc-800,\nbody.light-theme .bg-zinc-800\\/10,\nbody.light-theme .bg-zinc-800\\/30,\nbody.light-theme .bg-zinc-800\\/40,\nbody.light-theme .bg-zinc-800\\/50,\nbody.light-theme .bg-zinc-800\\/80,\nbody.light-theme .bg-black\\/20,\nbody.light-theme .bg-black\\/30,\nbody.light-theme .bg-black\\/40,\nbody.light-theme .bg-black\\/50,\nbody.light-theme .bg-black\\/60,\nbody.light-theme .bg-white\\/5 {\n  background-color: #f8fafc !important;\n  border-color: #94a3b8 !important;\n  color: #09090b !important;\n}\n\nbody.light-theme .bg-zinc-800\\/30.border-orange-500\\/20 {\n  background-color: #f8fafc !important;\n  border-color: #94a3b8 !important;\n  border-left: 4px solid #f97316 !important;\n}\n\n/* 6. Duidelijke, scherpe randen in Light Mode (#94a3b8 slate-400 voor echt contrast) */\nbody.light-theme .border-orange-500\\/20,\nbody.light-theme .border-orange-500\\/30,\nbody.light-theme .border-white\\/5,\nbody.light-theme .border-white\\/10,\nbody.light-theme .border-white\\/20,\nbody.light-theme .border-gray-700,\nbody.light-theme .border-gray-800,\nbody.light-theme .border-zinc-600,\nbody.light-theme .border-zinc-700,\nbody.light-theme .border-zinc-700\\/50,\nbody.light-theme .border-zinc-800 {\n  border-color: #94a3b8 !important;\n}\n\n/* Behoud dikke gekleurde linker-accentbalken op oefeningkaarten */\nbody.light-theme .border-l-orange-500 {\n  border-left: 4px solid #f97316 !important;\n}\nbody.light-theme .border-l-yellow-500 {\n  border-left: 4px solid #eab308 !important;\n}\nbody.light-theme .border-l-cyan-500 {\n  border-left: 4px solid #06b6d4 !important;\n}\n\n/* 7. Typografie: Diep Zwart (#09090b) & Koel Slate-Grijs */\nbody.light-theme .text-white:not(button):not(.bg-red-600):not(.bg-green-600):not(.bg-orange-500):not(.bg-orange-600):not(.bg-blue-600):not(.bg-emerald-600) {\n  color: #09090b !important;\n}\n\nbody.light-theme .text-gray-200,\nbody.light-theme .text-gray-300,\nbody.light-theme .text-zinc-200,\nbody.light-theme .text-zinc-300 {\n  color: #18181b !important;\n}\n\nbody.light-theme .text-gray-400,\nbody.light-theme .text-gray-500,\nbody.light-theme .text-zinc-400,\nbody.light-theme .text-zinc-500 {\n  color: #475569 !important;\n}\n\n/* 8. Invulvelden, Dropdowns & Sliders */\nbody.light-theme input:not([type=\"radio\"]):not([type=\"checkbox\"]):not([type=\"range\"]),\nbody.light-theme select,\nbody.light-theme textarea {\n  background-color: #ffffff !important;\n  color: #09090b !important;\n  border-color: #64748b !important;\n}\n\nbody.light-theme .workout-set-row input {\n  background-color: transparent !important;\n  border: none !important;\n}\n\nbody.light-theme input[type=\"range\"] {\n  background-color: #cbd5e1 !important;\n  accent-color: #09090b !important;\n}\n\n/* 9. Behoud altijd witte tekst op gekleurde actie-knoppen */\nbody.light-theme button.from-orange-600,\nbody.light-theme button.from-cyan-600,\nbody.light-theme button.from-emerald-600,\nbody.light-theme button.from-purple-600,\nbody.light-theme button.from-yellow-600,\nbody.light-theme button.from-blue-600,\nbody.light-theme button.bg-red-600,\nbody.light-theme button.bg-green-600,\nbody.light-theme button.bg-emerald-600,\nbody.light-theme button.bg-orange-500,\nbody.light-theme button.bg-orange-600,\nbody.light-theme button.bg-blue-600,\nbody.light-theme .bg-red-600,\nbody.light-theme .bg-green-600,\nbody.light-theme .bg-emerald-600 {\n  color: #ffffff !important;\n}\n\nbody.light-theme button.from-orange-600 *,\nbody.light-theme button.from-cyan-600 *,\nbody.light-theme button.from-emerald-600 *,\nbody.light-theme button.from-purple-600 *,\nbody.light-theme button.from-yellow-600 *,\nbody.light-theme button.from-blue-600 *,\nbody.light-theme button.bg-emerald-600 *,\nbody.light-theme .bg-red-600 *,\nbody.light-theme .bg-green-600 * {\n  color: #ffffff !important;\n}\n\nbody.light-theme .workout-set-row .set-weight-btn {\n  color: #09090b !important;\n}\nbody.light-theme .workout-set-row .set-weight-btn:hover {\n  color: #ea580c !important;\n}\n\nbody.light-theme .bg-zinc-900\\/60,\nbody.light-theme .bg-zinc-900\\/40,\nbody.light-theme .bg-zinc-800\\/60 {\n  background-color: #f8fafc !important;\n  color: #09090b !important;\n}\n\nbody.light-theme button.from-blue-600,\nbody.light-theme button.from-indigo-600 {\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
